(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wsp-extra-ten"] && !Shopify.designMode) return;
  try {
    const hideExpiredWspOffers = () => {
    document.querySelectorAll('[data-wsp-promotion-expires]').forEach((note) => {
      if (Date.now() >= Number(note.dataset.wspPromotionExpires)) note.style.display = 'none';
    });
  };
  hideExpiredWspOffers();
  window.addEventListener('pageshow', hideExpiredWspOffers);
  setInterval(hideExpiredWspOffers, 60000);
  new MutationObserver(hideExpiredWspOffers).observe(document.documentElement, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
